// ===========================================
// konakla - Supabase Browser Client
// ===========================================

import { createBrowserClient } from "@supabase/ssr";
import { createClient as createSupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

/**
 * SSR browser client (PKCE flow) - Google OAuth ve genel kullanım için.
 *
 * Module-level singleton: her çağrıda aynı instance döner. Aksi halde her
 * component kendi GoTrueClient'ını oluşturuyordu ve aynı storage key'i
 * paylaştıkları için Supabase "Multiple GoTrueClient instances detected"
 * uyarısı basıyordu. Auth state çakışması ve undefined behavior riski vardı.
 */
type BrowserClient = ReturnType<typeof createBrowserClient<Database>>;
let browserClientSingleton: BrowserClient | null = null;

export function createClient() {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn("[konakla] Supabase credentials eksik. .env.local dosyanızı kontrol edin.");
    return null;
  }

  if (browserClientSingleton) return browserClientSingleton;
  browserClientSingleton = createBrowserClient<Database>(supabaseUrl, supabaseAnonKey);
  return browserClientSingleton;
}

/**
 * PKCE olmayan plain client - Email OTP akışı için.
 * createBrowserClient otomatik PKCE ekliyor ve bu OTP doğrulamasını bozuyor.
 * Bu client PKCE kullanmaz, böylece signInWithOtp + verifyOtp düzgün çalışır.
 * Session kalıcılığı yoktur - doğrulama sonrası session ana SSR client'a aktarılır.
 */
export function createOtpClient() {
  if (!supabaseUrl || !supabaseAnonKey) return null;

  return createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      flowType: "implicit",
      persistSession: false,
      autoRefreshToken: false,
    },
  });
}
